import Header from './Header';
import { useAuth } from '../contexts/AuthContext';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Data from '../data/Data';

function UserSettings() {
    const { isLoggedIn } = useAuth();
    const [userData, setUserData] = useState('');
    const [country, setCountry] = useState(null);
    const [isHovered, setIsHovered] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const fileInputRef = useRef(null);
    const navigate = useNavigate();

    async function fetchUser() {
        try {
            const fetchedUserData = await Data.fetchUser();

            if (fetchedUserData.country) {
                const countryLowerCase = fetchedUserData.country.toLowerCase();
                const countryInfo = await Data.fetchCountries(countryLowerCase);

                setCountry(countryInfo);
            }

            setUserData(fetchedUserData);
        } catch (error) {
            console.error('Failed to fetch user:', error);
            Data.showErrorModal('Failed to fetch user:' + error);
        }
    }

    useEffect(() => {
        if (isLoggedIn) {
            fetchUser();
        } else
            navigate('/login');
    }, [isLoggedIn, navigate])

    const handleModifyAvatar = () => {
        fileInputRef.current.click();
    }

    const handleFileChange = async (e) => {
        setIsLoading(true);
        const file = e.target.files[0];

        if (file) {
            await Data.fetchUploadAvatar(file);
            window.location.reload();
        }
    }

    return (
        <div>
            <Header whiteLogo authButton />
            <div className="Login UserSettings container-fluid d-flex justify-content-center align-items-center">
                <div className="col-12 col-lg-8 box">
                    <h1 className="mb-4">Settings</h1>

                    <div className='row'>
                        <div className='col-sm-4'>
                            {!isLoading ? <div
                                className={`image-container ${isHovered ? 'hovered' : ''}`}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                onClick={() => handleModifyAvatar()}
                            >
                                <img
                                    src={userData.avatar}
                                    alt='profile'
                                />
                                <div className="overlay">
                                    <p className='pt-3'>Change Avatar</p>
                                </div>
                            </div> :
                                <div>
                                    <div className="spinner-border mt-5 ms-5" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            <input
                                type="file"
                                accept="image/*"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                        </div>
                        <div className='col-sm-8 pt-3 ps-4'>
                            <p>{userData.firstName} {userData.lastName}</p>
                            <p>{userData.email}</p>
                            <p>{userData.type && userData.type[0].toUpperCase() + userData.type.substring(1)}</p>
                            {country !== null && (
                                <div className='d-flex align-items-center'>
                                    <img
                                        src={`https://hatscripts.github.io/circle-flags/flags/${userData.country.toLowerCase()}.svg`}
                                        className='flag'
                                        width={32}
                                        alt={country.name.common}
                                    />
                                    <p className='pt-3 ps-2'>{country.name.common}</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='d-flex justify-content-end'>
                        <button className='btn btn-sm btn-outline-primary me-2' onClick={() => navigate('/dashboard')}>Back</button>
                        <button className='btn btn-sm btn-primary' onClick={() => navigate('/change-password')}>Change password</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserSettings;
